






































import Vue from 'vue'

export default Vue.extend({
  name: 'AmataUserListItem',
  props: {
    userData: {
      type: Object,
      required: true
    },
    onclickcall: {
      type: Function,
      required: true
    },
    initialized: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasSlots(): boolean {
      return this.$slots.default && this.$slots.default.length > 0
    }
  },
  methods: {
    handleClickContent() {
      this.$emit('click')
    },

    handleClickCall(userData: any, type: string) {
      this.onclickcall(userData, type)
    }
  }
})
